<div class="icon-gen-container">
    <h2 class="page-title">
        <mat-icon>apps</mat-icon>
        App Icon 產生器
    </h2>

    <!-- Upload Zone -->
    <mat-card class="upload-card" [class.drag-over]="isDragOver()" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()" (drop)="onDrop($event)" (click)="triggerFileInput()">
        <mat-card-content class="upload-content">
            @if (previewUrl()) {
            <img [src]="previewUrl()" class="preview-img" alt="預覽圖" />
            <p class="upload-hint change-hint">點擊或拖曳以更換圖片</p>
            } @else {
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <p class="upload-hint">點擊或拖曳圖片至此（建議 1024×1024 PNG）</p>
            }
        </mat-card-content>
    </mat-card>

    <input #fileInput type="file" accept="image/*" style="display:none" (change)="onFileSelected($event)" />

    @if (errorMsg()) {
    <p class="error-msg">{{ errorMsg() }}</p>
    }

    <!-- Size Selector -->
    <mat-card class="sizes-card">
        <mat-card-header>
            <mat-card-title>選擇 Icon 尺寸</mat-card-title>
            <span class="spacer"></span>
            <button (click)="selectAll()" class="btn-primary">全選</button>
            <button (click)="clearAll()" style="margin-left:8px" class="btn-primary">清除</button>
        </mat-card-header>
        <mat-card-content>
            <div class="chips-grid">
                @for (size of iconSizes; track size.label) {
                <mat-chip [class.chip-selected]="isSelected(size)" (click)="toggleSize(size)">
                    {{ size.label }}
                </mat-chip>
                }
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Generate Button -->
    <div class="action-row">
        <button [disabled]="!canGenerate()" (click)="generateIcons()" class="btn-primary">
            <mat-icon>auto_fix_high</mat-icon>
            產生 Icon（{{ selectedSizes().length }} 個）
        </button>
    </div>

    <!-- Results -->
    @if (generatedIcons().length > 0) {
    <mat-card class="result-card">
        <mat-card-header>
            <mat-card-title>產生結果</mat-card-title>
            <span class="spacer"></span>
            <button (click)="downloadAll()" class="btn-accent">
                <mat-icon>download</mat-icon>
                全部下載
            </button>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content>
            <div class="icons-grid">
                @for (icon of generatedIcons(); track icon.size.label) {
                <div class="icon-item">
                    <div class="icon-preview-wrap">
                        <img [src]="icon.dataUrl" [width]="icon.size.width > 128 ? 128 : icon.size.width"
                            [height]="icon.size.height > 128 ? 128 : icon.size.height" class="generated-icon"
                            [alt]="icon.size.label" />
                    </div>
                    <p class="icon-size-label">{{ icon.size.width }}×{{ icon.size.height }}</p>
                    <p class="icon-desc">{{ icon.size.description }}</p>
                    <button (click)="downloadIcon(icon)" class="btn-primary">
                        <mat-icon>download</mat-icon>
                        下載
                    </button>
                </div>
                }
            </div>
        </mat-card-content>
    </mat-card>
    }

    <!-- Hidden canvas for rendering -->
    <canvas #canvas style="display:none"></canvas>
</div>